import React from 'react';
import loader_logo from "../../../assets/images/UPG_site_logo.png"

const Loader = () => {
  return (
    <div className='loaderCont' >
      <div className='loaderBody'>
        <div class="loader">
         
           	<div class="drawing" id="loading">
              <div class="loading-dot"></div>
            </div>
        </div>
      </div>
    </div >
  );
};

export default Loader;
